import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const FeatureSectionImagesGridItemSchema = z.object({
  path: z.string(),
  alt: z.string().optional(),
  cols: z.number().optional(),
  verticalPosition: z.enum(["top", "center", "bottom"]).optional()
});
const FeatureSectionImagesGridSchema = z.object({
  id: z.string().optional(),
  items: FeatureSectionImagesGridItemSchema.array()
}).merge(SectionSpacingSchema);
export default FeatureSectionImagesGridSchema;
